<header class="topbar w-100 d-flex align-items-center">
  <!-- Hamburger (visible only < 1024px) -->
  <button class="btn hamburger-btn d-lg-none ms-2" type="button" data-bs-toggle="offcanvas"
    data-bs-target="#mobileSidebar" aria-controls="mobileSidebar" aria-label="Open menu">
    <svg width="20" height="20" viewBox="0 0 24 24">
      <path d="M3 6h18M3 12h18M3 18h18" stroke="#2f3355" stroke-width="2" stroke-linecap="round" />
    </svg>
  </button>

  <!-- App Name (hidden on mobile) -->
  <div class="ms-2 d-block fw-bold fs-6 fs-sm-5 mobile-header-text ">
    {{erpUser.account_name}} ({{erpUser.account_short_name}})
  </div>
  <div class="ms-2 fw-bold fs-6 fs-sm-5 small-mobile-text d-none">
    {{erpUser.account_short_name}}
  </div>

  <!-- Right icons -->
  <div class="ms-auto d-flex align-items-center gap-3">
    <button class="btn p-0" aria-label="Download" *ngIf="router.url == '/acms/acms-index'" (click)="exportAsImage()">
      <img src="../../../../../assets/img/acms/Downloadicon.svg" alt="Download">
      Download
    </button>

    <button class="btn p-0" aria-label="Notifications">
      <img src="../../../../../assets/img/acms/bell-03.svg" alt="Notifications">
    </button>
    <div class="position-relative">
      <button class="btn avatar-btn bg-white ps-1" (click)="toggleUserMenu()" [title]="roles.join(', ')" type="button"
        aria-haspopup="true" [attr.aria-expanded]="showUserMenu ? 'true' : 'false'">
        <div class="avatar d-flex gap-3">
          <span class="user-icon img-circular-container d-flex align-items-center">
            <img [src]="this.portal_main.profileImageUrl" alt="user image" srcset="" class="img-circular">

          </span>
          <span class="d-flex roles align-items-center">
            {{erpUser.party_name}}
          </span>

        </div>
      </button>
      <div class="profile-overlay-container bg-white p-1 rounded shadow" style="width: fit-content;"
        *ngIf="showUserMenu">
        <div style="width: 198px;">
          <div class="d-flex flex-column w-100" style="max-width: 198px;" >  
            <header class="d-flex gap-3 align-items-center align-self-start" style="width: 2.5rem;height: 2.4rem;margin-bottom: 4px;">
              <img [src]="this.portal_main.profileImageUrl" alt="user image" class="img-circular">
              <div class="d-flex flex-column w-100 justify-content-center align-self-stretch my-auto">
                <h3 class="mb-0 fs-6 lh-1 text-dark" style="width: 100%;min-width: 7rem;">
                  {{erpUser.party_name}}
                </h3>
              </div>
            </header>
            <hr class="m-0 w-100 border-secondary" style="min-height: 1px;">
          </div>
          <nav class="w-100 small lh-1 text-dark" style="max-width: 198px;">
            <div class="d-flex flex-column justify-content-center px-2 w-100 text-dark bg-light" style="height: 2rem;" (click)="goToProfile()">
              <div class="d-flex justify-content-between align-items-start cursor" >
                <div class="d-flex gap-2 align-items-center" >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <g clip-path="url(#clip0_971_6402)">
                      <path
                        d="M14.9318 15.6429C14.9318 12.5013 12.3532 9.95455 9.17234 9.95455H7.89247C4.71163 9.95455 2.13306 12.5013 2.13306 15.6429M8.53241 7.82143C6.96162 7.82143 5.68825 6.54806 5.68825 4.97728V4.26624C5.68825 2.69545 6.96162 1.42208 8.53241 1.42208C10.1032 1.42208 11.3766 2.69545 11.3766 4.26624V4.97728C11.3766 6.54806 10.1032 7.82143 8.53241 7.82143Z"
                        stroke="black" stroke-width="1.06656" stroke-linecap="round" stroke-linejoin="round" />
                    </g>
                    <defs>
                      <clipPath id="clip0_971_6402">
                        <rect width="17.0649" height="17.0649" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                  <span class="align-self-stretch my-auto">
                    My Profile
                  </span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M7.11035 11.3766L9.95451 8.53246L7.11035 5.68831" stroke="black" stroke-width="1.06656"
                    stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </div>
            </div>




            <div class="d-flex justify-content-between align-items-center p-2 w-100 cursor text-nowrap" style="height: 2rem;">
              <div class="d-flex gap-2 align-items-center align-self-stretch my-auto">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M11.3767 12.7987C11.3767 14.3695 10.1033 15.6429 8.53255 15.6429C6.96177 15.6429 5.68839 14.3695 5.68839 12.7987M3.55528 12.7987C3.30885 12.7987 3.07999 12.6711 2.95043 12.4615C2.82088 12.2518 2.8091 11.9901 2.91931 11.7697L4.26632 9.07565V7.11038C4.26632 4.45986 6.07914 2.23274 8.53255 1.60128C10.986 2.23274 12.7988 4.45986 12.7988 7.11038V9.07565L14.1458 11.7697C14.256 11.9901 14.2442 12.2518 14.1147 12.4615C13.9851 12.6711 13.7563 12.7987 13.5098 12.7987H3.55528Z"
                    stroke="black" stroke-width="1.06656" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <span class="align-self-stretch my-auto text-dark">
                  Notification
                </span>
              </div>
            </div>
            <div class="d-flex flex-column justify-content-center align-items-start cursor p-2 w-100" style="height: 2rem;" (click)="logOut()">
              <div class="d-flex gap-2 align-items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path
                    d="M12.0876 11.3766L14.9318 8.53247M14.9318 8.53247L12.0876 5.68831M14.9318 8.53247H4.97721M7.82137 14.9318H3.83955C2.89708 14.9318 2.13306 14.1678 2.13306 13.2253V3.83961C2.13306 2.89714 2.89708 2.13312 3.83955 2.13312H7.82137"
                    stroke="black" stroke-width="1.06656" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <span class="align-self-stretch my-auto text-dark">
                  Log Out
                </span>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</header>